"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var styles = {
    sortableList: react_1.css({
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        padding: 0,
        listStyle: 'none',
    }),
};
exports.default = styles;
